import { zhTW } from "@mui/material/locale";
import { createTheme } from "@mui/material/styles";

import colors from "./colors";
import componentStyleOverrides from "./customize";
import themePalette from "./palette";
import themeTypography from "./typography";

const getThemeSource = (customization, lang) => {
  const color = colors;

  const themeOption = {
    darkTextPrimary: color.darkTextPrimary,
    darkTextSecondary: color.darkTextSecondary,
    lightPrimary: color.lightPrimary,
    darkPrimary: color.darkPrimary,
    lightSecondary: color.lightSecondary,
    drawerBorder: color.drawerBorder,
    darkBackgroundText: color.darkBackgroundText,
    lightBackgroundText: color.lightBackgroundText,
    lightGray: color.lightGray,
    middleGray: color.middleGray,
    darkGray: color.darkGray,
    customization,
  };

  const themeOptions = {
    direction: "ltr",
    palette: themePalette(themeOption),
    mixins: {
      toolbar: {
        minHeight: "48px",
        padding: "16px",
        "@media (min-width: 600px)": {
          minHeight: "48px",
        },
      },
    },
    typography: themeTypography(themeOption, lang),
    components: componentStyleOverrides(themeOption),
    zIndex: {
      mobileStepper: 100,
      fab: 105,
      speedDial: 105,
      appBar: 110,
      drawer: 120,
      modal: 130,
      snackbar: 140,
      tooltip: 150,
    },
  };

  return createTheme(themeOptions, zhTW);
};

export default getThemeSource;
